import React from 'react';
import { CanonicalContact } from '../helpers/contactShape';
import { GroupedContacts } from '../helpers/groupByRole';
import ContactRow from './ContactRow';
import './ContactRoleGroup.scss';

interface ContactRoleGroupProps {
  group: GroupedContacts;
  onSelect: (contact: CanonicalContact) => void;
  subtitleVariant: 'role-only' | 'role-and-services';
}

const UNRECOGNIZED_WARNING: string =
  "This contact's role isn't a recognized type — selecting may have unexpected results.";

const roleSlug = (role: string): string =>
  role.toLowerCase().replace(/\s+/g, '-');

const ContactRoleGroup = ({
  group,
  onSelect,
  subtitleVariant,
}: ContactRoleGroupProps) => {
  const isUnrecognized: boolean = group.role === 'Unrecognized';

  const sectionClassName: string = isUnrecognized
    ? 'contact-role-group contact-role-group-unrecognized'
    : `contact-role-group contact-role-group-${roleSlug(group.role)}`;

  const headerLabel: string = isUnrecognized ? 'Unrecognized role' : group.role;

  return (
    <section className={sectionClassName}>
      <div className="group-header">{headerLabel}</div>

      {isUnrecognized && (
        <div className="group-warning">{UNRECOGNIZED_WARNING}</div>
      )}

      {group.contacts.map((contact: CanonicalContact) => (
        <ContactRow
          key={contact.id}
          contact={contact}
          onSelect={onSelect}
          subtitleVariant={subtitleVariant}
        />
      ))}
    </section>
  );
};

export default ContactRoleGroup;
